import { createAction, props } from "@ngrx/store";
import { AuthSite } from "./models/auth-logspace-locator.model";
import { AuthUser } from "./models/auth-user.model";
import { AuthPermissionList } from "./models/auth-permissions.model";

export const login = createAction(
  "[Auth] Login",
  props<{ bidaId: string; password: string }>(),
);

export const loginSuccess = createAction(
  "[Auth] Login Success",
  props<{
    user: AuthUser;
    site: AuthSite | null;
    siteList: AuthSite[];
  }>(),
);

export const loginFailure = createAction(
  "[Auth] Login Failure",
  props<{ error: any }>(),
);

export const logout = createAction("[Auth] Logout");

export const logoutSuccess = createAction("[Auth] Logout Success");

export const logoutFailure = createAction(
  "[Auth] Logout Failure",
  props<{ error: any }>(),
);

export const loadCurrentUser = createAction("[Auth] Load Current User");

export const loadCurrentUserSuccess = createAction(
  "[Auth] Load Current User Success",
  props<{
    user: AuthUser;
    site: AuthSite | null;
    siteList?: AuthSite[];
  }>(),
);

export const loadCurrentUserFailure = createAction(
  "[Auth] Load Current User Failure",
  props<{ error?: any }>(),
);

export const testAction = createAction("[Auth] Test Action");

export const siteSelected = createAction(
  "[Auth] Site Selected",
  props<{ user: AuthUser; site: AuthSite | null; siteList?: AuthSite[] }>(),
);

export const updateSite = createAction(
  "[Auth] Update Site",
  props<{ user: AuthUser; newSite?: AuthSite }>(),
);

export const updateSiteSuccess = createAction(
  "[Auth] Update Site Success",
  props<{ newSite: AuthSite; permissions: AuthPermissionList }>(),
);

export const updateSiteFailure = createAction(
  "[Auth] Update Site Failure",
  props<{ error: any }>(),
);

// Re-fetch the permission list for the currently selected site without
// rewriting the site selection. Dispatched by the auth interceptor when the
// server returns 403 so the menu stays in sync with what the back-end
// actually allows. No-op if there's no logged-in user or no current site.
export const refreshPermissions = createAction(
  "[Auth] Refresh Permissions",
);

export const refreshPermissionsSuccess = createAction(
  "[Auth] Refresh Permissions Success",
  props<{ permissions: AuthPermissionList }>(),
);

export const refreshPermissionsFailure = createAction(
  "[Auth] Refresh Permissions Failure",
  props<{ error: any }>(),
);

export const AuthActions = {
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
  logoutFailure,
  loadCurrentUser,
  loadCurrentUserSuccess,
  loadCurrentUserFailure,
  updateSite,
  updateSiteSuccess,
  updateSiteFailure,
  refreshPermissions,
  refreshPermissionsSuccess,
  refreshPermissionsFailure,
  siteSelected,
  testAction,
};
